import {  Text, Html, Sparkles, Center ,useTexture ,useGLTF } from '@react-three/drei'
import { useFrame, useThree } from '@react-three/fiber'
import { useEffect, useRef, useState } from 'react'
import * as THREE from 'three'

export default function Experience()
{
        const { nodes } = useGLTF('./model/portfolio.glb')
        // console.log(nodes)

        const bakedTexture = useTexture('./model/baked.jpg')
        bakedTexture.flipY = false

        const { camera, size, mouse } = useThree()
        const targetPosition = useRef(new THREE.Vector3())

        const baseZ = 9
        const baseY = 6
        const fov = 45
        const lookAtTarget = new THREE.Vector3(0, 4, 4)

        function getBaseCameraPosition(aspect, baseY, baseZ) {
        return new THREE.Vector3(0, baseY, baseZ / aspect)
        }

        function getCursorOffset(mouse, strengthX, strengthY) {
        return new THREE.Vector3(mouse.x * strengthX, mouse.y * strengthY, 0)
        }

        const basePositionRef = useRef(new THREE.Vector3())

        const isTouchDevice = useRef(false)

        useEffect(() => {
        const aspect = size.width / size.height
        const isPortrait = size.height >= size.width

        let baseZLocal, baseYLocal, lookAtY

        if (size.width <= 600) {
            baseYLocal = 5
            baseZLocal = 16
            lookAtY = 5
        } else if (size.width <= 1024) {
            baseYLocal = 5
            baseZLocal = 16
            lookAtY = 4
        } else {
            baseYLocal = 4
            baseZLocal = 16
            lookAtY = 4
        }

        isTouchDevice.current = 'ontouchstart' in window || navigator.maxTouchPoints > 0
        
        const basePos = new THREE.Vector3(0, baseYLocal, baseZLocal)
        
        basePositionRef.current.copy(basePos)

        let adjustedFov = fov
        camera.fov = adjustedFov

        if (aspect < 1) {
            const fovMultiplier = Math.min(1 + (1 - aspect) * 0.1, 1.1)
            adjustedFov *= fovMultiplier
        }
        camera.position.copy(basePos)
        camera.lookAt(0, lookAtY, 0)
        camera.updateProjectionMatrix()

        lookAtTarget.set(0, lookAtY, 4)
        }, [size, camera])

        useFrame(() => {
        const basePos = basePositionRef.current
        let offset

        if (isTouchDevice.current) {
        offset = new THREE.Vector3(0, 0, 0)
        } else {
        offset = getCursorOffset(mouse, 0.05, 0.05)
        }

        targetPosition.current.lerp(basePos.clone().add(offset), 0.03)

        camera.position.copy(targetPosition.current)
        camera.lookAt(lookAtTarget)
        })

    return <>

        <color args={ [ '#030202' ] } attach="background" />


        //model
        {Object.values(nodes).map((node, index) =>
        node.geometry ? (
            <mesh key={index} geometry={node.geometry}>
            <meshBasicMaterial map={bakedTexture} />
            </mesh>
        ) : null
        )}

        <Sparkles
            size={ 6 }
            scale={ [ 50, 15, 50 ] }
            position-y={ 10 }
            position-z={ -15 }
            speed={ 0.01 }
            count={ 150 }
        />
    </>
}